//Filtros en frontal

export const CUSTOM_TAG_FILTERS = {
    RENOVACION: {
        "id": "customTags",
        "name": "Otros filtros",
        "type": "",
        "unit": "",
        "values": [
            {
                "id": "renovacion",
                "name": "OFERTA RENOVACIÓN",
                "type": "customTag"
            }
        ]
    },
    COLLECTIVES: {
        "id": "customTags",
        "name": "Otros filtros",
        "type": "",
        "unit": "",
        "values": [
            {
                "id": "colectivos",
                "name": "Colectivos",
                "type": "customTag"
            }
        ]
    },
    NEW_R2R_MODEL: {
        "id": "customTags",
        "name": "Otros filtros",
        "type": "",
        "unit": "",
        "values": [
            {
                "id": "profile306",
                "name": "DTO. EXCLUSIVO",
                "type": "customTag"
            }
        ]
    }
}

